module.exports = __webpack_public_path__ + "media/marketing_area/Vendors_Dynamic_Products_3-7180f886.jpg";